import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Arrow growing and pointing to the right, used for sharing
 */
export const ShareIcon: FunctionComponent<ShareIconProps> = ({ size = 24, strokeColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <Path
        d='M13.9649 2.30693C14.2451 2.19094 14.5678 2.25556 14.7823 2.47002L22.2823 9.97002C22.5751 10.2629 22.5751 10.7377 22.2823 11.0306L14.7823 18.5306C14.5678 18.745 14.2451 18.8096 13.9649 18.6936C13.6846 18.5776 13.502 18.3036 13.502 18.0003V14.2728C8.44606 14.5559 4.86513 17.6349 3.44827 19.1438L3.44729 19.1429C3.28774 19.3146 3.0795 19.4337 2.84964 19.4808C2.61576 19.5285 2.37229 19.5001 2.1553 19.4007C1.93821 19.3011 1.75801 19.1347 1.64163 18.9261C1.52626 18.7192 1.4801 18.4815 1.50784 18.2464H1.50686C1.88582 14.9619 3.77436 12.0921 6.17483 10.056C8.34854 8.21221 11.0136 6.99445 13.502 6.78545V3.00029C13.502 2.69694 13.6846 2.42302 13.9649 2.30693ZM15.002 7.50029C15.002 7.91447 14.6661 8.25023 14.252 8.25029C11.9955 8.25029 9.33707 9.33977 7.14456 11.1995C5.25678 12.8008 3.78072 14.9189 3.20315 17.2815C5.20684 15.4396 9.05917 12.7503 14.252 12.7503C14.6661 12.7503 15.002 13.0861 15.002 13.5003V16.1897L20.6914 10.5003L15.002 4.81084V7.50029Z'
        fillRule='evenodd'
        clipRule='evenodd'
        fill={strokeColor || colors.iconDefault}
      />
    </Svg>
  )
}

type ShareIconProps = {
  size?: string | number
  strokeColor?: string
}
